import { useMutation, useQueryClient } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
import { ApiError } from 'src/types/interfaces/api-error';
import { delayedCallbackExecution } from 'src/utils/delayed-callback-execution';
import { updateEmployeesGroupDefault } from '../lib/employees-groups';
import { employeesGroupsKeys } from '../query-keys/employees-groups';
import { isApiErrorMessage } from 'src/api/utils/is-api-error-message';
import { ApiErrorMessage } from '../types/api-error-message';
import { employeesGroupsEditDefaultApiErrorsTranslations } from '../../constants/api-errors-translations';
export const useUpdateEmployeesGroupDefault = (onSuccess?: () => void) => {
  const { t } = useTranslation(['employeesGroups', 'common']);
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      employeeGroupToken,
      isDefault,
    }: {
      employeeGroupToken: string;
      isDefault: boolean;
    }) => updateEmployeesGroupDefault(employeeGroupToken, isDefault),
    onSuccess: () => {
      delayedCallbackExecution(1000, () => {
        queryClient.invalidateQueries({
          queryKey: employeesGroupsKeys.lists(),
        });
      });
      toast.success(
        t('employeesGroups:common.editEmployeesGroup.default.successMessage'),
      );
      onSuccess?.();
    },
    onError: (error: ApiError) => {
      const errorMessage = error?.response?.data?.message;

      if (
        isApiErrorMessage<ApiErrorMessage>(
          errorMessage,
          employeesGroupsEditDefaultApiErrorsTranslations,
        )
      ) {
        toast.error(
          t(employeesGroupsEditDefaultApiErrorsTranslations[errorMessage]),
        );
        return;
      }
      toast.error(errorMessage || t('common:errorMessages.somethingWentWrong'));
    },
  });
};
